<template>
  <div class="card border rounded-4 shadow-sm">
    <div class="card-body p-3 workflow-soft-card">
      <div class="row g-3 align-items-end">
        <div class="col-12 col-xl-4">
          <label class="text-secondary text-xxs fw-bold text-uppercase mb-2 d-block">Action Name</label>
          <input
            :value="actionName"
            type="text"
            class="form-control text-xs bg-white"
            placeholder="e.g. Approve"
            @input="$emit('update:actionName', $event.target.value)"
          />
        </div>

        <div class="col-12 col-xl-5">
          <label class="text-secondary text-xxs fw-bold text-uppercase mb-2 d-block">Description</label>
          <input
            :value="description"
            type="text"
            class="form-control text-xs bg-white"
            placeholder="Optional but recommended"
            @input="$emit('update:description', $event.target.value)"
          />
        </div>

        <div class="col-12 col-md-6 col-xl-2">
          <button
            type="button"
            class="btn btn-primary-dark text-xs rounded-3 w-100"
            :disabled="actionSaving"
            @click="$emit('save')"
          >
            {{ actionSaving ? 'Saving...' : (isUpdate ? 'Update Action' : 'Create Action') }}
          </button>
        </div>

        <div class="col-12 col-md-6 col-xl-1">
          <button
            type="button"
            class="btn btn-outline-secondary text-xs rounded-3 w-100"
            @click="$emit('reset')"
          >
            Clear
          </button>
        </div>
      </div>

      <p v-if="duplicateWarning" class="text-danger text-xxs mb-0 mt-3">
        {{ duplicateWarning }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ActionForm',
  props: {
    actionName: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    actionSaving: {
      type: Boolean,
      default: false,
    },
    isUpdate: {
      type: Boolean,
      default: false,
    },
    duplicateWarning: {
      type: String,
      default: '',
    },
  },
  emits: ['update:actionName', 'update:description', 'save', 'reset'],
};
</script>
